import {
  formSpecification as commonFormSpecification,
  type RecordPolicePresenceFormData as CommonRecordPolicePresenceFormData,
} from "../common/recordPolicePresence/responseToNhs.js";

export const formSpecification = commonFormSpecification;

export type RecordPolicePresenceFormData = CommonRecordPolicePresenceFormData;
